import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Translation", webpackPrefetch: true */ './lazyIndex')
);

export let lazyCheckCanTranslate = new LazyImport(lazyModule, m => m.checkCanTranslate);
export let lazyInitSupportedLanguages = new LazyImport(lazyModule, m => m.initSupportedLanguages);
export let lazyInitAndGetSupportedLanguageMap = new LazyImport(
    lazyModule,
    m => m.initAndGetSupportedLanguageMap
);
export let lazyGetLocaleOfSupportedLanguageMap = new LazyImport(
    lazyModule,
    m => m.getLocaleOfSupportedLanguageMap
);
export let lazyGetOgmaSupportedLanguageTag = new LazyImport(
    lazyModule,
    m => m.getOgmaSupportedLanguageTag
);
export let lazyGetSupportedLanguageMap = new LazyImport(lazyModule, m => m.getSupportedLanguageMap);
export let lazyGetUserLanguageName = new LazyImport(lazyModule, m => m.getUserLanguageName);
export let lazyGetIsUserLocaleSupported = new LazyImport(
    lazyModule,
    m => m.getIsUserLocaleSupported
);
export let lazyTranslateText = new LazyImport(lazyModule, m => m.translateText);
export let lazyUpdateTranslationOptions = new LazyImport(
    lazyModule,
    m => m.updateTranslationOptions
);
